export default class CarouselItem {
  constructor($el) {
    this.$el = $el;
  }

  getEl(){
    return this.$el;
  }

  activate(){
    this.$el.classList.add('active')
  }

  deactivate(){
    this.$el.classList.remove('activate')
  }
}